import {
  CardsGrid,
  ContainerHeader,
  ContentStack,
  InnerContainer,
  SectionSubtitle,
  SectionTitle,
  SectionWrapper,
} from './styles';
import InstructionsCard from 'shared/components/cards/InstructionsCard';

export const HowItWorksSection = () => {
  const steps = [
    { num: '1', title: 'Simulação do seu crédito', desc: 'Faça análise a partir do seus dados pessoais' },
    {
      num: '2',
      title: 'Envio da proposta',
      desc: 'Enviaremos uma mensagem para que você escolha o seu produto Motorola.',
    },
    { num: '3', title: 'Análise dos seus documentos', desc: 'Envie seus documentos como RG, CNH, RNE ou CNH.' },
    { num: '4', title: 'Confirme seus dados', desc: 'Confirme seus dados pessoais, de contato e endereço' },
    {
      num: '5',
      title: 'Pronto! Seu financiamento ficará ativo',
      desc: 'Utilize nosso aplicativo do Dimo para que pague todas as parcelas em dia',
    },
  ];
  return (
    <SectionWrapper>
      <InnerContainer>
        <ContentStack>
          <ContainerHeader>
            <SectionTitle variant="h2">Como Funciona</SectionTitle>
            <SectionSubtitle variant="body1">Tudo que você precisa saber antes de iniciar!</SectionSubtitle>
          </ContainerHeader>

          <CardsGrid>
            {steps.map((step, index) => 
              <InstructionsCard step={step} index={index} key={index}></InstructionsCard>
            )}
          </CardsGrid>
        </ContentStack>
      </InnerContainer>
    </SectionWrapper>
  );
};
